/* divos.lt tema — bendras elgesys visuose puslapiuose */
(function () {
  const theme = window.theme = window.theme || {};
  const routes = theme.routes || {};
  const settings = theme.settings || {};
  const ls = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  theme.storage = ls;
  const lock = on => document.body.classList.toggle('lock', on || ['menu-open', 'mc-open', 'filters-open', 'popup-open'].some(c => document.body.classList.contains(c)));

  /* ---------- Pinigų formatas ---------- */
  theme.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || theme.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = (num, dec, th, sep) => {
      th = th === undefined ? '.' : th; sep = sep === undefined ? ',' : sep;
      if (isNaN(num) || num == null) return 0;
      const parts = (num / 100).toFixed(dec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? sep + parts[1] : '');
    };
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    let v = '';
    switch (m && m[1]) {
      case 'amount': v = n(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = n(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = n(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = n(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = n(cents, 2, "'", '.'); break;
      default: v = n(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]+>/g, '');
  };

  /* ---------- Pranešimai ---------- */
  theme.toast = function (msg, type) {
    let t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.className = 'toast show' + (type ? ' ' + type : '');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 3200);
  };

  /* ---------- Širdutės ---------- */
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const HEART = 'M12 21s-7.5-4.6-9.6-9C.9 8.7 2.9 5 6.5 5c2.1 0 3.4 1.1 4.2 2.3.6.9 2 .9 2.6 0C14.1 6.1 15.4 5 17.5 5c3.6 0 5.6 3.7 4.1 7-2.1 4.4-9.6 9-9.6 9z';
  theme.hearts = function (el) {
    if (calm || !el || settings.heartsEnabled === false || !Element.prototype.animate) return;
    const r = el.getBoundingClientRect();
    const css = getComputedStyle(document.documentElement);
    const c1 = css.getPropertyValue('--rose').trim() || '#EF95CF', c2 = css.getPropertyValue('--rose-dark').trim() || '#BF3A83';
    const count = Math.random() < .5 ? 1 : 2;
    for (let i = 0; i < count; i++) {
      const size = i ? 16 : 22;
      const h = document.createElement('span');
      h.className = 'heart-pop';
      h.style.width = h.style.height = size + 'px';
      h.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + HEART + '" fill="' + (i ? c2 : c1) + '"/></svg>';
      const x = r.left + r.width * (i ? .6 : .46) - size / 2, y = r.top - size * .2;
      const dx = (i ? 1 : -1) * (8 + Math.random() * 10), rise = 64 + Math.random() * 22 + i * 10, rot = (i ? 1 : -1) * 12;
      document.body.appendChild(h);
      h.animate([
        { transform: 'translate(' + x + 'px,' + y + 'px) scale(.3)', opacity: 0 },
        { transform: 'translate(' + (x + dx * .3) + 'px,' + (y - 16) + 'px) scale(1.12) rotate(' + rot * .5 + 'deg)', opacity: 1, offset: .22 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y - rise) + 'px) scale(.85) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 950 + i * 120, delay: i * 120, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'both' }).onfinish = () => h.remove();
    }
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('.card .add[data-variant-id], [data-add-to-cart], [data-buy-now], .mc-plus, .rec .plus, [data-hearts]');
    if (b && !b.disabled && !b.getAttribute('aria-disabled')) theme.hearts(b);
  }, true);

  /* ---------- Neseniai žiūrėtos ---------- */
  theme.recent = {
    list: () => ls.get('divos-recent', []),
    push(handle) { if (!handle) return; const l = this.list().filter(h => h !== handle); l.unshift(handle); ls.set('divos-recent', l.slice(0, 12)); }
  };

  /* ---------- Kortelės „+“ (greitas įdėjimas) ---------- */
  document.addEventListener('click', e => {
    const add = e.target.closest('.card .add[data-variant-id]');
    if (!add) return;
    e.preventDefault();
    if (!window.DivosCart) { window.location.href = add.closest('.card').querySelector('a').href; return; }
    const label = add.querySelector('span');
    add.disabled = true; add.classList.add('done');
    window.DivosCart.add([{ id: Number(add.dataset.variantId), quantity: 1 }])
      .then(() => { if (label) label.textContent = 'Įdėta ✓'; })
      .catch(msg => theme.toast(msg || 'Nepavyko įdėti į krepšelį', 'err'))
      .finally(() => setTimeout(() => { add.disabled = false; add.classList.remove('done'); if (label) label.textContent = 'Į krepšelį'; }, 1500));
  });

  /* ---------- Antraštės krepšelio nuoroda → šoninis krepšelis ---------- */
  document.addEventListener('click', e => {
    const link = e.target.closest('#HeaderCartLink');
    if (!link || theme.template === 'cart' || !settings.cartDrawer || !window.DivosCart) return;
    e.preventDefault();
    window.DivosCart.open();
  });

  /* ---------- Mobilus meniu ---------- */
  document.addEventListener('click', e => {
    if (e.target.closest('[data-menu]')) { document.body.classList.add('menu-open'); lock(true); }
    if (e.target.closest('#MenuDrawer [data-close]')) { document.body.classList.remove('menu-open'); lock(); }
  });

  /* ---------- Išskleidžiamas meniu (kompiuteryje) ---------- */
  const megaItems = [...document.querySelectorAll('nav.cats li.has-mega')];
  let megaT;
  const closeMega = () => megaItems.forEach(li => { li.classList.remove('open'); li.firstElementChild.setAttribute('aria-expanded', 'false'); });
  megaItems.forEach(li => {
    const a = li.firstElementChild;
    a.setAttribute('aria-haspopup', 'true'); a.setAttribute('aria-expanded', 'false');
    li.addEventListener('mouseenter', () => { clearTimeout(megaT); megaT = setTimeout(() => { closeMega(); li.classList.add('open'); a.setAttribute('aria-expanded', 'true'); }, 80); });
    li.addEventListener('mouseleave', () => { clearTimeout(megaT); megaT = setTimeout(closeMega, 160); });
  });
  document.querySelectorAll('nav.cats li:not(.has-mega)').forEach(li => li.addEventListener('mouseenter', () => { clearTimeout(megaT); closeMega(); }));

  /* ---------- Karuselės rodyklės ---------- */
  document.addEventListener('click', e => {
    const arr = e.target.closest('[data-slide]');
    if (!arr) return;
    const row = document.getElementById(arr.dataset.slide);
    if (row) row.scrollBy({ left: row.clientWidth * 0.8 * Number(arr.dataset.dir || 1), behavior: 'smooth' });
  });

  /* ---------- Paieška su pasiūlymais ---------- */
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  document.querySelectorAll('form[data-predictive]').forEach(form => {
    const input = form.querySelector('input[name="q"]');
    const box = form.querySelector('.suggest');
    if (!input || !box) return;
    const popular = (form.dataset.popular || '').split(',').map(s => s.trim()).filter(Boolean);
    let timer, ctrl;
    const chips = () => popular.length ? '<div class="sg-sec"><h5>Populiarios paieškos</h5><div class="sg-chips">' + popular.map(p => '<button type="button" class="chip" data-sq="' + esc(p) + '">' + esc(p) + '</button>').join('') + '</div></div>' : '';
    const show = html => { box.innerHTML = html; box.hidden = !html; };
    const run = () => {
      const q = input.value.trim();
      if (!q) { show(chips()); return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      const url = routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=4&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(r => r.ok ? r.text() : Promise.reject())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const sec = doc.querySelector('.shopify-section') || doc.body;
          show(sec.innerHTML.trim());
        })
        .catch(err => { if (!err || err.name !== 'AbortError') show(''); });
    };
    input.addEventListener('focus', run);
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('keydown', e => { if (e.key === 'Escape') { box.hidden = true; input.blur(); } });
    box.addEventListener('click', e => {
      const c = e.target.closest('[data-sq]');
      if (c) { e.preventDefault(); input.value = c.dataset.sq; input.focus(); run(); }
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) box.hidden = true; });
  });

  /* ---------- −10 % langas naujiems lankytojams ---------- */
  const pop = document.getElementById('NewsletterPopup');
  let popT = null;
  const openPop = () => { if (!pop) return; pop.classList.add('show'); document.body.classList.add('popup-open'); lock(true); const i = pop.querySelector('input[type="email"]'); if (i) setTimeout(() => i.focus({ preventScroll: true }), 300); };
  const closePop = () => { if (!pop) return; pop.classList.remove('show'); document.body.classList.remove('popup-open'); lock(); ls.set('divos-popup', 1); };
  theme.showNewsletterPopup = openPop;
  function schedulePopup() {
    if (!pop || popT || ls.get('divos-popup', 0) || ['cart', 'customers/login', 'customers/register', 'customers/account', 'password'].includes(theme.template)) return;
    const ckEl = document.getElementById('CookieBanner');
    if (ckEl && ckEl.classList.contains('show')) return;
    popT = setTimeout(() => {
      const busy = ['mc-open', 'menu-open', 'filters-open'].some(c => document.body.classList.contains(c));
      if (!busy) openPop();
    }, (settings.popupDelay || 7) * 1000);
  }
  if (pop) {
    if (pop.dataset.posted === 'true') { ls.set('divos-popup', 1); openPop(); }
    else if (pop.dataset.error === 'true') openPop();
    else if (!document.getElementById('CookieBanner')) schedulePopup();
    pop.addEventListener('click', e => {
      if (e.target.closest('[data-pop-close]')) closePop();
      const c = e.target.closest('[data-copy]');
      if (c) {
        const code = c.dataset.copy;
        (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(() => {}).finally(() => { const s = c.querySelector('small'); if (s) s.textContent = 'Nukopijuota ✓'; });
      }
    });
  }

  /* ---------- Slapukų sutikimas (Shopify Customer Privacy API) ---------- */
  const ck = document.getElementById('CookieBanner');
  let privacy = null;
  const showCookie = (withSettings) => {
    if (!ck) return;
    const saved = ls.get('divos-consent', {});
    const a = ck.querySelector('[name="ck-analytics"]'), m = ck.querySelector('[name="ck-marketing"]');
    if (a) a.checked = !!saved.a; if (m) m.checked = !!saved.m;
    if (withSettings) openCkSettings();
    ck.classList.add('show');
  };
  const openCkSettings = () => { const s = ck.querySelector('.ck-set'); if (s) s.hidden = false; const b = ck.querySelector('[data-ck="settings"]'); if (b) { b.textContent = 'Išsaugoti pasirinkimą'; b.dataset.ck = 'save'; } };
  const applyConsent = (a, m) => {
    ls.set('divos-consent', { a: a ? 1 : 0, m: m ? 1 : 0, t: Date.now() });
    if (privacy && privacy.setTrackingConsent) {
      try { privacy.setTrackingConsent({ analytics: !!a, marketing: !!m, preferences: true, sale_of_data: !!m }, () => {}); } catch (e) {}
    }
    ck.classList.remove('show');
    schedulePopup();
  };
  if (ck) {
    const decide = () => {
      const saved = ls.get('divos-consent', null);
      const need = privacy && typeof privacy.shouldShowBanner === 'function' ? privacy.shouldShowBanner() : !saved;
      if (!saved && need) setTimeout(() => showCookie(false), 600); else schedulePopup();
    };
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => { if (!err) privacy = window.Shopify.customerPrivacy; decide(); });
    } else decide();
    ck.addEventListener('click', e => {
      const b = e.target.closest('[data-ck]'); if (!b) return;
      const k = b.dataset.ck;
      if (k === 'settings') { openCkSettings(); return; }
      if (k === 'all') applyConsent(true, true);
      else if (k === 'necessary') applyConsent(false, false);
      else if (k === 'save') applyConsent(ck.querySelector('[name="ck-analytics"]').checked, ck.querySelector('[name="ck-marketing"]').checked);
    });
  }
  document.addEventListener('click', e => { if (e.target.closest('[data-cookie-settings]')) { e.preventDefault(); showCookie(true); } });

  /* ---------- Esc ---------- */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if (document.body.classList.contains('menu-open')) { document.body.classList.remove('menu-open'); lock(); }
    if (pop && pop.classList.contains('show')) closePop();
    closeMega();
  });
})();


/* Antraštės aukštis CSS kintamajame --header-h (lipnioms juostoms po antrašte) */
(function () {
  const h = document.querySelector('.section-header');
  if (!h) return;
  const set = () => document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(h);
})();